export enum AllowedPaymentMethods {
  CASH_EQUIVALENT = "CASH_EQUIVALENT",
  ANY = "ANY",
  DO_NOT_ACCEPT_PAYMENT = "DO_NOT_ACCEPT_PAYMENT",
}
